var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      style: _vm.modalStyle,
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        maskClosable: false,
        forceRender: true,
        fullscreen: "",
        switchFullscreen: "",
        wrapClassName: "ant-modal-cust-warp",
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      !_vm.designerVisible
        ? _c("div", { staticClass: "top-toolbar" }, [
            _c(
              "div",
              {
                staticClass: "toolbar-left",
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  gap: "8px",
                },
              },
              [
                _c(
                  "a-button",
                  {
                    key: "templateSetting",
                    attrs: { icon: "setting" },
                    on: { click: _vm.handleTemplateSetting },
                  },
                  [_vm._v("模板设置")]
                ),
                _c(
                  "a-button",
                  {
                    key: "printPreview",
                    attrs: { type: "primary", icon: "printer" },
                    on: { click: _vm.handlePrintPreview },
                  },
                  [_vm._v("打印预览")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c("template", { slot: "footer" }, [
        _c("div", { staticClass: "footer-bar" }, [
          _c(
            "div",
            { staticClass: "footer-right" },
            [
              _c("a-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("取消"),
              ]),
            ],
            1
          ),
        ]),
      ]),
      !_vm.designerVisible
        ? _c(
            "a-spin",
            { attrs: { spinning: _vm.loading, tip: "正在加载送货单..." } },
            [
              _c("div", { staticClass: "hiprint-container" }, [
                !_vm.templateJson && !_vm.loading
                  ? _c(
                      "div",
                      { staticClass: "no-template" },
                      [
                        _c("a-empty", {
                          attrs: {
                            description:
                              "暂无打印模板，请先执行 print_shd.sql 并点击模板设置",
                          },
                        }),
                      ],
                      1
                    )
                  : _c("div", { staticClass: "preview-wrapper" }, [
                      _c("div", {
                        ref: "printContent",
                        staticClass: "print-content",
                        style: {
                          transform: `scale(${_vm.zoomLevel / 100})`,
                          transformOrigin: "top center",
                        },
                      }),
                    ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm.designerVisible
        ? _c(
            "div",
            { staticClass: "designer-wrapper" },
            [
              _c("EmbeddedDesigner", {
                ref: "embeddedDesigner",
                attrs: {
                  billType: _vm.billTypeCode,
                  billTypeName: _vm.billTypeName,
                  billNo: _vm.currentBillNo,
                  templateId: _vm.selectedTemplateId,
                  billData: _vm.printData,
                },
                on: { close: _vm.onDesignerClose, saved: _vm.onDesignerSaved },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }